import { useEffect } from 'react';
import { parse, stringify } from 'qs';
import { isEqual, omit } from 'lodash-es';
import { ValidCategories } from '@/app/(pages)/results/constants';

export const bookingDateAndCapacityParams = [
  'checkinDate',
  'checkoutDate',
  'checkInDate',
  'checkOutDate',
  'capacityAdult',
  'capacityChild',
  'capacityChildAges',
  'rooms',
];

export const useNormalizeQueryParams = () => {
  useEffect(() => {
    const queryParams = parse(location.search.replace('?', ''));

    let updatedQueryParams = { ...queryParams };

    // 1. booking 관련 파라미터 제거
    updatedQueryParams = omit(updatedQueryParams, bookingDateAndCapacityParams);

    // 2. shortcut 제거
    updatedQueryParams = omit(updatedQueryParams, ['shortcut']);

    // 3. category 유효성 검증 및 기본값 설정
    const category = updatedQueryParams.category;
    const isValidCategory =
      typeof category === 'string' && ValidCategories.includes(category as (typeof ValidCategories)[number]);

    if (!isValidCategory) {
      updatedQueryParams.category = 'local';
    }

    // 4. entryPoint 사용 후 제거
    if (updatedQueryParams.entryPoint) {
      delete updatedQueryParams.entryPoint;
    }

    // 변경된 사항 반영
    if (!isEqual(queryParams, updatedQueryParams)) {
      const newQueryString = stringify(updatedQueryParams);
      if (newQueryString) {
        window.history.replaceState(null, '', `?${newQueryString}`);
      }
    }
  }, []);
};
